/**
 *
 */

var Menu = (function($) {
  function initMenu() {
    $("body").toggleClass("has-nav");
  }

  function init() {
    if (!$(".header").length) {
      return;
    }

    $(".hamburger").click(function() {
      initMenu();
    });
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Menu.init);
